module.exports = __webpack_public_path__ + "media/images/icons/variety-icon-bc89717c474ec5bdd0a4312be594e4b8.svg";